// 酒店七大类图标（icon / icon1 / icon2）统一用 2026-09 改版的线框图标，见 src/assets/img/category/
// （和 src/icons/svg/ 的同名文件是同一份，改图标两边一起改）。变量名沿用旧图片的名字，指向的已是新图标
import Group1 from "@/assets/img/category/sun.svg";
import Group2 from "@/assets/img/category/clean.svg";
import Group3 from "@/assets/img/category/bed.svg";
import Group4 from "@/assets/img/category/location.svg";
import Group5 from "@/assets/img/category/food.svg";
import Group6 from "@/assets/img/category/money.svg";
import Group7 from "@/assets/img/category/services.svg";
import icon_FB from "@/assets/img/category/food.svg";
import icon_Amenities from "@/assets/img/category/sun.svg";
import icon_Cleanness from "@/assets/img/category/clean.svg";
import icon_Location from "@/assets/img/category/location.svg";
import icon_Room from "@/assets/img/category/bed.svg";
import icon_Service from "@/assets/img/category/services.svg";
import icon_Value from "@/assets/img/category/money.svg";
import img_english from "@/assets/img/img_english.png"
import img_chinese from "@/assets/img/img_chinese.png"
import img_German from "@/assets/img/img_German.png"
import img_Italian from "@/assets/img/img_Italian.png"

export default {
    // 模块加载状态（components/common/ModuleLoadState.vue）
    ModuleLoad: {
        loading: 'Caricamento…',
        slow: 'Ci vuole più del solito',
        failed: 'Impossibile caricare',
        retry: 'Riprova',
    },
    countryArr:[
        {
            name:'中文',
            value:'zh',
            icon:img_chinese
        },
        {
            name:'English',
            value:'en',
            icon:img_english
        },
        {
            name:'Italiano',
            value:'it',
            icon:img_Italian
        },
        {
            name:'Deutsch',
            value:'de',
            icon:img_German
        },
    ],
    message: {
        language: 'Italiano',
        gmb:'Un prodotto di Where to know Insights GmbH',
        Settings_saved:'Impostazioni salvate',
        CurrentPassword:"La password corrente non può essere vuota",
        CurrentPassword1:"La conferma della password non corrisponde alla password",
        CurrentPassword2:"Password modificata",
        sidebar:"Disconnessione effettuata con successo",
        competitors:'Seleziona prima un hotel',
        competitors1:'Errore del server. Riprova più tardi.',
        DateTimePickerHome: 'La data di fine non può superare la data corrente',
        DateTimePickerHome1: 'Impossibile caricare gli hotel. Riprova.',
        DateTimePickerHome2: 'Seleziona almeno una piattaforma',
        platformOverview: 'File caricato con successo',
        platformOverview1: 'La dimensione del file non può superare 5MB',
        platformOverview2: 'Carica prima un file',
        login:'Inserisci username e password',
        login1:"Accesso effettuato con successo",
        login2:"Accesso fallito. Nome utente o password incorretti",
        login3:"La richiesta di accesso è fallita. Riprova più tardi",
        Reviews:"Non ci sono commenti per il momento. Rifiltra",
        Reviews1:"La tua sessione è scaduta. Accedi ora...",
        Reviews2:"Errore del server. Riprova più tardi",
        Reviews3:"Errore di rete. Riprova più tardi",
        Exporting:"Esportazione in corso, attendere prego...",
        AI:"Il contenuto originale non può essere vuoto e non può essere tradotto",
        AI1:"L'interfaccia di traduzione ha restituito un'eccezione. Riprova",
        AI2:"Traduzione fallita. Controlla la tua rete o riprova",
        AI3:"Copiato negli appunti",
        AI4:"Copia fallita. Riprova",
        AI5:"Inviato con successo",
        AI6:"Nessun contenuto tradotto",
        AI7:"Lingua di destinazione non ottenuta. Riprova",
        AI8:"Traduzione fallita. Riprova",
        AI9:"Per favore, scrivi il contenuto originale, Signore",
        AI10:"Elaborazione in corso. Operazione più tardi",
        AI11:"Seleziona prima la lingua di traduzione",
        AI12:"Impossibile ottenere nuovo contenuto AI",
        FilterContainer:"Le condizioni di filtro sono state applicate",
        FilterContainer1:"L'operazione di applicazione è stata annullata",
        onlyTrans:'Seleziona la lingua',
        ReplyResponeRate:'Devono essere selezionate almeno una piattaforma',
        LikeSuccess:'Questa risposta è stata salvata. Visita la sezione dei modelli di risposta in seguito per visualizzarla.',
        LikeTooltip:'Clicca prima su "Genera"',
        noLikeSuccess:'Il preferito è stato rimosso con successo',
        requestFailed:'Richiesta fallita. Riprova.',
        noLikeTooltip:'Annulla preferito',
        Saved_successfully:'Salvato ora',
        Notes_saved:'Note salvate',
        Removed_from_Reply_Library:'Rimosso dalla Libreria risposte',
        Couldn_remove_from_Reply_Library:"Impossibile rimuovere dalla Libreria risposte",
    },
    sidebar: {
        replayGuide: 'Rivedi la guida',
        language: 'Lingua',
        // 侧边栏 New 胶囊、品牌模式里拼出来的菜单名（集团名 / 品牌名是数据，只翻译固定部分）
        newBadge:'Nuovo',
        groupOverview:'Panoramica {group}',
        thailandLuxuryOverview:'Panoramica lusso Thailandia',
        brandDetails:'Dettagli {brand}',
    },
    sidebarGuide: {
        skip: 'Salta',
        prev: 'Indietro',
        next: 'Avanti',
        finish: 'Fine',
        steps: {
            hotelSelector: { title: 'Cambia hotel', desc: "Clicca sul nome dell'hotel per passare rapidamente tra tutte le strutture che gestisci." },
            moduleSwitch: { title: 'Modalità Hotel/Ristorante', desc: 'Passa dalla vista Hotel a quella Ristorante — ognuna con la propria dashboard e il proprio menu.' },
            aiChat: { desc: "Fai domande in linguaggio naturale e ottieni risposte immediate e basate sui dati sulle prestazioni del tuo hotel." },
            overview: { desc: "La dashboard del tuo hotel — valutazioni sulle piattaforme, tasso di risposta, recensioni recenti e problemi da tenere d'occhio, a colpo d'occhio." },
            reviews: { desc: 'Leggi e rispondi a ogni recensione degli ospiti, monitora i casi segnalati e gestisci i tuoi modelli di risposta.' },
            competition: { desc: 'Confrontati con i concorrenti nelle vicinanze su valutazioni e recensioni delle OTA.' },
            insights: { desc: 'Report più approfonditi e panoramiche a livello di brand per individuare tendenze tra le tue strutture.' },
            surveys: { desc: 'Raccogli il feedback degli ospiti durante e dopo il soggiorno con sondaggi personalizzati.' },
            restaurantSelector: { title: 'Cambia ristorante', desc: 'Clicca sul nome del ristorante per passare da un locale all\'altro tra quelli che gestisci.' },
            restaurantAiChat: { desc: 'Fai domande in linguaggio naturale e ottieni subito risposte basate sui dati sulle prestazioni del tuo ristorante.' },
            restaurantOverview: { desc: 'La dashboard del tuo ristorante: valutazioni sulle piattaforme, tasso di risposta, recensioni recenti, punteggi per area e menzioni di staff e piatti.' },
            restaurantReviews: { desc: 'Leggi e rispondi a ogni recensione, segui i casi segnalati e gestisci impostazioni e modelli di risposta.' },
            restaurantCompetition: { desc: 'Confrontati con i ristoranti vicini su valutazioni e recensioni delle piattaforme.' },
            restaurantInsights: { desc: 'Report mensili e analisi di più lungo periodo sull\'andamento del ristorante.' },
            generals: { desc: "Gestisci le impostazioni dell'account e trova risposte nel Centro assistenza." },
        },
    },
    // 新手导览名称（Help Center「Replay guide」列表，见 utils/guideTours.js）
    guideTours: {
        sidebar: 'Navigazione laterale',
        home: 'Panoramica hotel',
        reviews: 'Recensioni',
        restaurantReviews: 'Recensioni F&B',
        restaurantSidebar: 'Navigazione laterale',
        restaurantHome: 'Panoramica ristorante',
        skip: 'Salta',
        prev: 'Indietro',
        next: 'Avanti',
        finish: 'Fine',
    },
    restaurantHomeGuide: {
        steps: {
            platforms: { title: 'Panoramica piattaforme', desc: 'Valutazione, tasso di risposta e tempo medio di risposta di ogni piattaforma, e circa quante recensioni a punteggio pieno servono per arrivare al tuo obiettivo.' },
            activity: { title: 'Attività recente e classifiche', desc: '«{recent}» mostra le recensioni delle ultime 72 ore: cambia Type per vedere cosa gli ospiti hanno apprezzato o criticato. «{topLists}» elenca i punti di forza e i problemi più citati del mese scorso.' },
            filters: { title: 'Piattaforme e periodo', desc: 'Scegli piattaforme e periodo: tutti i punteggi e le classifiche qui sotto si aggiornano di conseguenza.' },
            scores: { title: 'Punteggi', desc: 'Il punteggio complessivo e ogni area: cibo, bevande, servizio e altro. Passa sull\'icona dell\'occhio per i conteggi positivi / neutri / negativi, cliccala per le sottocategorie.' },
            attention: { title: '{areasWarning}', desc: 'Le sottocategorie che abbassano il punteggio. Quando tutto va bene, questa sezione resta vuota.' },
            competitors: { title: 'Concorrenti', desc: 'Come il tuo punteggio complessivo si confronta con i concorrenti che segui.' },
            mentions: { title: 'Menzioni di staff e piatti', desc: 'Il personale, i piatti e le bevande più citati dagli ospiti, e quanto sono positive le menzioni. Clicca su una riga per leggere le recensioni.' },
        },
    },
    reviewsGuide: {
        steps: {
            period: { title: 'Periodo', desc: 'Scegli un periodo o date precise: le schede delle piattaforme e l\'elenco delle recensioni qui sotto si aggiornano insieme.' },
            tools: { title: 'Ricerca, filtri ed esportazione', desc: 'Cerca nel testo delle recensioni, cambia la visualizzazione, filtra per punteggio, tipo di recensione, sentiment o categoria ed esporta le recensioni che stai guardando.' },
            platforms: { title: 'Piattaforme', desc: 'Ogni scheda mostra il punteggio medio e il numero di recensioni della piattaforma nel periodo. Clicca su una scheda per mostrare o nascondere le sue recensioni.' },
            card: { title: 'Dettagli recensione', desc: 'Ogni scheda è una recensione. Etichette come «{mismatch}» segnalano le recensioni da guardare con attenzione, e «{goTo}» apre l\'originale. Clicca su «{expand}» per l\'analisi completa: apriamo questa.' },
            score: { title: 'Punteggio WQI', desc: 'Il punteggio AI di ciò che l\'ospite ha scritto, da 1 a 10 (le piattaforme a 5 punti vengono convertite). Passa il mouse sopra per vedere la scala dei colori.' },
            translate: { title: 'Traduzione', desc: 'Scegli una lingua per tradurre la recensione e passa qui dalla traduzione all\'originale.' },
            guestTags: { title: 'Tag dell\'ospite', desc: '«{guestTags}» sono i dettagli che l\'ospite ha scelto sulla piattaforma pubblicando la recensione: voti per cibo, servizio e atmosfera, dimensione del gruppo, livello di rumore e altro. Puoi filtrare le recensioni in base a questi nei Filtri.' },
            analysis: { title: 'Analisi AI', desc: '«{dimensions}» mostra di quali temi parla la recensione, quanto spazio occupa ciascuno e che punteggio ha. «{summary}» riassume la recensione in una riga.' },
            note: { title: 'Note', desc: 'Lascia una nota interna per il tuo team. Resta in WTK e non viene mai pubblicata sulla piattaforma.' },
            actions: { title: 'Inoltra e rispondi', desc: '«{forward}» invia la recensione via email a un collega. «{reply}» prepara una bozza di risposta AI basata su «{replySetting}»: modificala e copiala sulla piattaforma.' },
            actionsGoogle: { title: 'Inoltra e rispondi', desc: '«{forward}» invia la recensione via email a un collega. «{reply}» prepara una bozza di risposta AI basata su «{replySetting}»: modificala, copiala o pubblicala direttamente su Google.' },
            actionsReplied: { title: 'Inoltra e rispondi', desc: '«{forward}» invia la recensione via email a un collega. Questa ha già una risposta, quindi il pulsante mostra «{replied}»; nelle recensioni senza risposta, «{reply}» prepara una bozza AI basata su «{replySetting}» da modificare e copiare sulla piattaforma.' },
        },
    },
    homeGuide: {
        skip: 'Salta',
        prev: 'Indietro',
        next: 'Avanti',
        finish: 'Fine',
        steps: {
            overview: { title: 'Panoramica Dashboard', desc: "Qui trovi le prestazioni complessive della piattaforma — tasso di risposta, attività delle ultime 24 ore ed evidenze/problemi della settimana scorsa — per capire subito lo stato del tuo hotel." },
            dateRange: { title: 'Intervallo di tempo', desc: "Cambia qui l'intervallo di date e le piattaforme di recensione — tutti i grafici e i dati sotto si aggiornano automaticamente in base alla tua selezione." },
            needsAttention: { title: 'Problemi da monitorare', desc: "Elenca le sottocategorie più da tenere d'occhio per numero di recensioni, punteggio e impatto — clicca su una riga per i dettagli." },
            highlights: { title: 'Punti di forza e miglioramenti', desc: 'Passa da Punti di forza a Problemi per vedere le parole chiave più citate dagli ospiti la settimana scorsa, sia positive che da migliorare.' },
            evidence: { title: 'Visualizza le recensioni originali', desc: 'Clicca su una qualsiasi delle card di categoria qui sotto (Posizione, Pulizia, ecc.) per aprire le recensioni originali degli ospiti dietro quel punteggio.' },
        },
    },
    // 404 页（views/error/404.vue）
    NotFound:{
        desc:"Spiacenti, la pagina che cerchi non esiste",
        backHome:"Torna alla home",
    },
    menu:{
        // Quality Standards 页：侧栏用短名，页面头部用全称。
        'Quality Standards': 'Standard di qualità',
        // 新版 WTK Luxury Standards 的侧栏名（只给 featureGates.js 的 LUXURY_STANDARDS_HOTELS）。页面本身只有英文
        'Luxury Standards': 'Luxury Standards',
        // 半年报两个侧栏入口（RouterMenu.vue）。de / it 暂用英文
        'Market Signals': 'Market Signals',
        'Half-Year Review': 'Half-Year Review',
        // 酒店那份半年报改名 Period Review（周期长度会变，名字里不写时长）；F&B 仍用上面那条
        'Period Review': 'Period Review',
        QualityStandards_Title: 'Feedback degli ospiti e standard di qualità',
        QualityStandards_EmptyTitle: 'Nessun dato sugli standard per questa struttura',
        QualityStandards_EmptyDesc: "Questa struttura non è inclusa nell'attuale set di dati LQA / Forbes / MICHELIN. Seleziona una struttura inclusa dal selettore hotel.",
        'AI Chat':'Intelligenza',
        // Solo per il selettore Hotel/F&B/Brand della sidebar.
        'Hotel': 'Hotel',
        'F&B': 'F&B',
        'Brand': 'Marchio',
        BrandOverview2:'Portfolio Insights',
        BrandOverviewList:'Panoramica marchio',
        'Hotel Dashboard': 'Dashboard dell\'Hotel',
        'Reviews & Reply': 'Recensioni e Risposte',
        'Case Management': 'Gestione casi',
        'Hotel Reviews': 'Recensioni hotel',
        'Restaurant Reviews': 'Recensioni ristorante',
        'Reviews': 'Recensioni',
        'Replies': 'Risposte',
        'Competitors' : 'Concorrenti',
        'Competitors_OTA_Reports': 'Panoramica di mercato',
        'Competitors_Benchmarks': 'Benchmark concorrenti',
        'Settings' : 'Impostazioni',
        'Staff Management': 'Gestione del personale',
        'Connections':'Connessioni',
        // 品牌模式侧栏的 Active Signal Details 入口
        ActiveSignalDetails:'Dettagli segnali attivi',
        // 以下是侧栏会用到、it 之前缺的菜单词条（menu 是整块对象取值，缺了不会回退英文，侧栏直接空白）
        'Hotel Overview':'Panoramica hotel',
        Reports:'Report',
        PortiolioBriefing:'Briefing portfolio',
        BrandOverview:'Panoramica marchio',
        'Restaurant Dashboard':'Dashboard del ristorante',
        ReplyLike:'Modello di risposta',
        'Reply Setting':'Impostazioni risposta',
        Restaurant:'Ristorante',
        'Help Center (FAQ)':'Centro assistenza (FAQ)',
        Dashboards:'Dashboard',
        dashboard:'Dashboard',
        'Restaurant Overview':'Panoramica ristorante',
        'Reviews & Replies':'Gestione casi',
        'Hotel Reply Setting':'Impostazioni risposta hotel',
        'Hotel Reply Template':'Modello di risposta hotel',
        'Food & Beverage':'Ristorazione',
        'F&B Reviews':'Recensioni F&B',
        'F&B Reply Setting':'Impostazioni risposta F&B',
        'F&B Reply Template':'Modello di risposta F&B',
        Competition:'Concorrenza',
        'Hotel Competitors':'Concorrenti hotel',
        'Restaurant Competitors':'Concorrenti ristorante',
        Insights:'Analisi',
        'Brand Overview':'Panoramica marchio',
        Generals:'Generale',
        Setting:'Impostazioni',
        Survey:'Sondaggio',
        Surveys:'Sondaggi',
        'During Stay':'Durante il soggiorno',
        'Post Stay':'Dopo il soggiorno',
        'Survey Detail':'Dettaglio sondaggio',
        'Needs Attention':'Da gestire',
        'Reply Library':'Libreria risposte',
    },

    Filter:'Filtro',

    SML_ReviewsShowBox:{
        emptyState:{
            title:'Nessuna recensione corrispondente',
            description:'Nessuna recensione corrisponde ai filtri attuali. Prova a modificarli o a reimpostarli.',
            resetBtn:'Reimposta filtri',
        },
    },
    inputPlaceholder:"Inserisci",
    selectPlaceholder:"Seleziona",
    Example:'Esempio:',
    Score:'Punteggio',
    Email:'Email',
    Proportion:'Proporzione',
    No_data:'Nessun dato',
    // 图表空状态（EchartsNoData）。原来 it 缺这两条，又没有 fallbackLocale，会直接显示键名
    echartsNoData1:'Nessun dato disponibile per questo periodo',
    echartsNoData2:'Prova a selezionare un altro intervallo di date o ricontrolla più tardi, quando saranno disponibili nuovi dati',
    // WTK-578 图表空状态按原因区分（EchartsNoData 的 reason）
    echartsNoData_noScored1:'Nessuna recensione con punteggio in questo periodo',
    echartsNoData_noScored2:"L'andamento mostra solo i periodi con recensioni valutate. Prova un intervallo più lungo, ad esempio il trimestre corrente.",
    echartsNoData_noCategory1:'Nessuna recensione menziona {category} in questo periodo',
    echartsNoData_noCategory2:'Torna al punteggio complessivo o prova un intervallo più lungo, ad esempio il trimestre corrente.',
    Diff:'Differenza',
    Hotel:'Hotel',
    Reviews:"Recensioni",
    Submit:"Invia",
    Title:"Titolo",
    Loading:'Caricamento',
    Report_not_ready:'Report non ancora disponibile',
    Report_not_ready_desc:'Questo periodo non ha ancora raggiunto il momento di generazione, oppure i dati sono ancora in elaborazione. Riprova più tardi.',
    LoadingData:'Caricamento dati',
    LoadingNewData:'Caricamento nuovi dati',
    LoadingInitialData:'Caricamento dati iniziali',
    Category:'Categoria',
    CategoryObj:{
        "Location & Neighborhood":"Posizione e Quartiere",
        "Cleanness":"Pulizia",
        "Room Facilities & Comfort":"Dotazioni e Comfort della Stanza",
        "Hotel Amenities & Atmosphere":"Servizi e Atmosfera dell'Hotel",
        "Food & Beverage":"Cibo e Bevande",
        "Guest Experience & Service":"Esperienza dell'Ospite e Servizio",
        "Value for Money":"Rapporto Qualità-Prezzo",
        "Room Comfort":"Comfort della Stanza",
        "Cleanliness":"Pulizia",
        Location:'Posizione',
        'Room & Amenities':'Stanza e Servizi',
        'F&B Experience':'Esperienza Cibo e Bevande',
        'Hotel Facilities & Amenities':'Dotazioni e Servizi dell\'Hotel',
        Services:'Servizi',
        Room:'Stanza',
        Amenities:'Servizi',
        "F & B":"Cibo e Bevande",
        "F&B":"Cibo e Bevande",
        Service:'Servizio',
        Value:'Valore',
        'Location & Neighbourhood':'Posizione e Quartiere',
    },
    CategoryLabel:[
        {
            name1:"Posizione",
            name2:"Posizione e Quartiere",
            icon:Group4,
            icon1:icon_Location,
            value:"Posizione",
        },
        {
            name1:"Pulizia",
            name2:"Pulizia",
            icon:Group2,
            icon1:icon_Cleanness,
            value:"Pulizia",
        },
        {
            name1:"Stanza",
            name2:"Dotazioni e Comfort della Stanza",
            icon:Group3,
            icon1:icon_Room,
            value:"Stanza",
        },
        {
            name1:"Servizi",
            name2:"Servizi e Atmosfera dell'Hotel",
            icon:Group1,
            icon1:icon_Amenities,
            value:"Servizi",
        },
        {
            name1:"Cibo e Bevande",
            name2:"Cibo e Bevande",
            icon:Group5,
            icon1:icon_FB,
            value:"Cibo e Bevande",
        },
        {
            name1:"Servizio",
            name2:"Esperienza dell'Ospite e Servizio",
            icon:Group7,
            icon1:icon_Service,
            value:"Servizio",
        },
        {
            name1:"Valore",
            name2:"Rapporto Qualità-Prezzo",
            icon:Group6,
            icon1:icon_Value,
            value:"Valore",
        },
    ],
    DateMonth:{
        Jan:'Gennaio',
        Feb:'Febbraio',
        Mar:'Marzo',
        Apr:'Aprile',
        May:'Maggio',
        Jun:'Giugno',
        Jul:'Luglio',
        Aug:'Agosto',
        Sep:'Settembre',
        Oct:'Ottobre',
        Nov:'Novembre',
        Dec:'Dicembre'
    },
    OTAs:{
        HOLIDAYCHECK:'HolidayCheck',
        HRS:'HRS',
        LASTMINUTE:'lastminute.com',
        TRIVAGO:'trivago',
        PRICELINE:'Priceline',
        HOTELSCOM:'Hotels.com',
        HOTELESCOM:'Hoteles.com',
        RAKUTEN:'Rakuten Travel',
        TRAVELOKA:'Traveloka',
        HOSTELWORLD:'Hostelworld',
        TRAVELOCITY:'Travelocity',
        ORBITZ:'Orbitz',
        LUXURYESCAPES:'Luxury Escapes',
        INTERNAL:'Internal',
        Internal:'Internal',
        MAKEMYTRIP:'MakeMyTrip',
        HOTELDE:'hotel.de',
        HolidayCheck:'HolidayCheck',
        Lastminute:'lastminute.com',
        Trivago:'trivago',
        Priceline:'Priceline',
        Hotelscom:'Hotels.com',
        Rakuten:'Rakuten Travel',
        Traveloka:'Traveloka',
        Hostelworld:'Hostelworld',
        Travelocity:'Travelocity',
        Orbitz:'Orbitz',
        LuxuryEscapes:'Luxury Escapes',
        MakeMyTrip:'MakeMyTrip',
        HotelDe:'hotel.de',
        BOOKING:'Booking.com',
        TRIP:'Ctrip.com',
        EXPEDIA:'Expedia',
        GOOGLE:'Google',
        TRIPADVISOR:'Tripadvisor',
        OPENTABLE:'OpenTable',
        YELP:'Yelp',
        WONGNAI:'Wongnai',
        Booking:'Booking.com',
        Trip:'Ctrip.com',
        Google:'Google',
        Expedia:'Expedia',
        Tripadvisor:'Tripadvisor',
        Yelp:'Yelp',
        Wongnai:'Wongnai',
        'OpenTable':'Open Table',
        'Google Map':'Google Maps',
    },
    baseLanguages:[
        { label: "Inglese", value: "Inglese" },
        { label: "Tedesco", value: "Tedesco" },
        { label: "Francese", value: "Francese" },
        { label: "Italiano", value: "Italiano" },
        { label: "Spagnolo", value: "Spagnolo" },
        { label: "Portoghese", value: "Portoghese" },
        { label: "Svedese", value: "Svedese" },
        { label: "Cinese", value: "Cinese" },
        { label: "Giapponese", value: "Giapponese" },
        { label: "Coreano", value: "Coreano" },
        { label: "Arabo", value: "Arabo" },
        { label: "Russo", value: "Russo" },
        { label: "Turco", value: "Turco" },
        // { label: "Hindi", value: "Hindi" },
        { label: "Thai", value: "Thai" },
        { label: "Vietnamita", value: "Vietnamita" },
        { label: "Indonesiano / Bahasa", value: "Indonesiano / Bahasa" },
        { label: "Olandese", value: "Olandese" },
        { label: "Polacco", value: "Polacco" },
        { label: "Greco", value: "Greco" },
        { label: "Ebraico", value: "Ebraico" },
    ],
    TravellerType:{
        "Couple":"Coppia",
        "Solo":"Solo",
        "Group":"Gruppo",
        "Family":"Famiglia",
        "Business":"Affari",
        "unknown":"sconosciuto",
    },
    punctuationMarks:{
        quotationMarks1:' " ',
        quotationMarks2:' " ',
    },

    login:{
        Open_in_app_tip:'La visualizzazione di questa pagina da mobile potrebbe compromettere l\'esperienza. Aprire invece l\'app?',
        Open_in_app_title:'Continuare su Where to Know?',
        Open_in_app_subtitle:'Questa pagina funziona meglio nell\'app Where to Know',
        Open_in_app_button:'Apri App',
        Reset_your_password:'Reimposta la tua password',
        Email_address:'Indirizzo email',
        Log_in:'Accedi',
        Reset_password:'Reimposta password',
        Log_in_to_start_your_session:'Accedi per iniziare la sessione',
        placeholder1:'Nome utente / Email',
        placeholder2:'Password',
        Remember_me:'Ricordami',
        module_hotel:'Hotel',
        module_restaurant:'Ristorante',
        module_brand:'Marchio',
        Forget_your_password:'Hai dimenticato la password?',
        Password_requirements:'Requisiti per la password:',
        Password_requirements1:'deve includere un numero, una lettera maiuscola,',
        Password_requirements2:'e una lettera minuscola.',
        Verify_your_email:'Verifica la tua email',
        Verify_your_email1:"Ti abbiamo inviato un codice di registrazione a sei cifre per email.",
        Verify_your_email2:"Inserisci il codice di seguito.",
        Email_me_another_verification_code:"Inviarei un altro codice di verifica",
        Repeat_new_password:"Ripeti la nuova password",

        Are_you_sure_you_want_to_logout:'Sei sicuro di voler disconnetterti',
        Confir_Logout:'Conferma disconnessione',
        Confirm:'Conferma',
        Cancel:'Annulla',
    },
    selectHotel:{
        Select_Your_Hotel:"Seleziona il tuo Hotel",
        Select_Your_Restaurant:"Seleziona il tuo Ristorante",
        Select_Your_Brand:"Seleziona il tuo Marchio",
        Choose_any_of_the_following_hotels:"Scegli uno qualsiasi degli hotel seguenti",
        Choose_a_restaurant_to_continue:"Scegli un ristorante per continuare",
        Choose_a_brand_to_continue:"Scegli un marchio per continuare",
        Loading_hotels:"Caricamento hotel",
        Confirm_Continue:"Conferma e Continua",
        Need_assistance_Contact_support:"Hai bisogno di assistenza? Contatta il supporto",
    },
    current:{
        Date:"Data di oggi:",
        Updated:"Ora locale:",
    },
    chat:{
        title:'Intelligenza',
        welcomeTitle:'Chiedimi qualsiasi cosa sui tuoi dati delle recensioni',
        welcomeSub:'Assistente di analisi · Beta',
        betaNotice:'Le risposte generate dall\'IA devono essere verificate insieme ai dati della dashboard.',
        betaNoticeL1:'L\'assistente IA è ancora in fase beta e le risposte potrebbero essere occasionalmente imprecise.',
        betaNoticeL2:'Verifica sempre le informazioni importanti con i dati della dashboard.',
        betaBadge:'Assistente IA (Beta)',
        quotaWarnDay:"Hai usato circa il {pct}% della capacità dell'assistente AI di questo hotel per oggi — si reimposta domani.",
        quotaWarnMonth:"Hai usato circa il {pct}% della capacità dell'assistente AI di questo hotel per questo mese — si reimposta il giorno 1.",
        thinking:'Ragionamento',
        steps:'Passaggi ({n})',
        analyzing:'Analisi delle recensioni…',
        newChat:'Nuova chat',
        delete:'Elimina',
        deleteConfirm:'Eliminare questa conversazione? L\'azione non può essere annullata.',
        deleted:'Conversazione eliminata',
        feedbackUp:'Utile',
        feedbackDown:'Non utile',
        copy:'Copia',
        copied:'Copiato',
        copyFailed:'Copia non riuscita',
        unknownUser:'Utente sconosciuto',
        byAuthor:'di {name}',
        groupToday:'Oggi',
        groupYesterday:'Ieri',
        groupLast7:'Ultimi 7 giorni',
        groupLast30:'Ultimi 30 giorni',
        groupOlder:'Meno recenti',
        insightsTitle:'{n} elementi da esaminare questa settimana',
        insightsBadge:'Riepilogo attenzione',
        insightsUrgent:'{n} ad alta priorità',
        insightsCta:'Su cosa dovrei concentrarmi?',
        periodSwitch:'Periodo:',
        period7d:'Ultimi 7 giorni',
        periodMonth:'Questo mese',
        periodQuarter:'Questo trimestre',
        periodYtd:'Da inizio anno',
        samePeriod:'Stessa domanda per {period}',
        insightsView:'Chiedi all\'IA',
        insightsAsk:'Quali anomalie sono state segnalate di recente? Analizza cause e azioni consigliate.',
        evidence:'Fonti',
        hideEvidence:'Nascondi',
        evidenceHint:'Clicca sull’etichetta “Fonti” sotto una risposta per vedere su cosa si basa.',
        viewReportPdf:'Apri PDF del report',
        reportPdfError:'Impossibile aprire il PDF del report. Riprova.',
        evReviews:'Recensioni',
        evReports:'Report',
        evWeb:'Web',
        viewOnSource:'Vedi originale',
        viewSource:'Vedi fonte',
        expandReview:'Mostra di più',
        collapseReview:'Mostra meno',
        placeholder:'Scrivi una domanda — Invio per inviare (Shift+Invio per andare a capo)',
        suggestions:[
            "Ci sono anomalie da tenere d'occhio?",
            'Perché le recensioni sono peggiorate questo mese?',
            'Stiamo raggiungendo gli obiettivi questo mese?',
            'Come ci posizioniamo rispetto ai concorrenti?',
            'Quali membri dello staff sono stati più elogiati questo mese, e per cosa esattamente?',
            'Eventi o notizie locali che potrebbero influire sulla domanda?',
        ],
        tools:{
            query_metrics:'Interrogazione metriche',
            list_reviews:'Recupero recensioni',
            render_chart:'Generazione grafico',
            load_skill:'Caricamento metodo di analisi',
        },
    },
    DateTimePickerHome:{
        label1:'Ultima settimana',
        label2:'Ultimo mese',
        label3:'Ultimi 3 mesi',
        label4:'Quest\'anno',
        Custom:'Personalizzato',
        allFrequencyOpts:[
            { value: "DAY", displayLabel: "Giorno" },
            { value: "WEEK", displayLabel: "Settimana" },
            { value: "MONTH", displayLabel: "Mese" },
        ]
    },
    HotelIndex:{
        title:'Dashboard dell\'Hotel',
        FilterSheet:{
            OtaPlatform:'Piattaforma OTA',
            DateRange:'Intervallo di date',
            DateFrequency:'Data e frequenza',
            DateToolbar:'Data e barra strumenti',
            Apply:'Applica',
            More:'Altro',
        },
        PackageBanner:{
            regionLabel:'Avviso abbonamento',
            viewPlans:'Vedi piani',
            contactSales:'Contatta il commerciale',
            trialEnded:'La prova gratuita è terminata il {date}',
            trialEndsOn:'La prova gratuita termina il {date}',
            daysRemaining:'{days} giorni rimanenti',
            readOnlyPurgeNoDays:'Accesso in sola lettura fino all\'eliminazione dei dati',
        },
        Platform_Overview:{
            title:'1. Panoramica delle piattaforme',
            tooltip1:'Questa sezione verrà aggiornata settimanalmente',
            text2:"Tasso di risposta",
            Reviews:"Recensioni",
            Reviews1:"Recensioni",
            ReviewCount:"Recensione | Recensioni",
            text3:"Tempo medio di risposta",
            text4:"giorni",
            noResponsesYet:"Nessuna risposta finora",
            lessThanOneDay:"< 1 giorno",
            text5:"Ospiti:",
            text6:"Impegno totale",
            title1:"Breve aggiornamento mattutino",
            text7:'Caricamento dati fallito. Riprova a ricaricare più tardi',
            otherPlatforms:'Altre piattaforme',
            moveToExpanded:'Sposta tra le principali',
            replaceWith:'Sostituisci con',
            moreCount:'+{count} altri',
            showAll:'Mostra tutti',
            compactView:'Vista compatta',
            manageSources:'Gestisci fonti',
            searchSourcesPlaceholder:'Cerca fonti...',
            featuredSection:'In evidenza ({count})',
            otherSourcesSection:'Altre fonti ({count})',
            moveToFeatured:'Metti in evidenza',
            cancel:'Annulla',
            save:'Salva',
            noSearchResults:'Nessuna fonte corrisponde a "{query}"',
            ReviewBySources:{
                'Direct booking':'Prenotazione diretta',
                DirectBookingSurvey:'Prenotazione diretta (sondaggio)',
                DirectbookingText:'I dati mostrati sono indicative. Numeri esatti e benchmark saranno visibili una volta attiva l\'integrazione.',
                'Information Platforms':'Piattaforme informative',
                OTAs:'Piattaforme OTA',
                'Social Media':'Social media',
                Directbooking:'Prenotazione diretta',
                InformationPlatforms:'Piattaforme informative',
                SocialMedia:'Social media',
            },
            ScoreImprovement:{
                current:'Attuale',
                target:'Obiettivo',
                title:'Simulatore miglioramento punteggio',
                subtitle:'Trascina il cursore per impostare il punteggio obiettivo',
                reviewsNeeded:'recensioni necessarie per raggiungere',
                projectionDisclaimer:'Previsione basata sull\'andamento delle recensioni passate. I risultati effettivi possono variare.',
                maxScoreReached:'Punteggio massimo raggiunto',
                alreadyAbove:'Già al di sopra dell\'obiettivo',
                noData:'Nessun dato di punteggio disponibile',
                predicted:'previsto',
                assuming:'Supponendo che le nuove recensioni ottengano',
                targetLabel:'Punteggio obiettivo',
                analyzing:'Analizzando',
                estimatedAt:'Stimato in',
                month:'mese',
                months:'mesi',
                estimatedTooltip:'Basato sulla media degli ultimi 3 mesi; un volume maggiore o un tasso di 5 stelle più alto possono accelerare i tempi.',
                // ── Modello di stato stazionario (media recente) ──
                ceilingLabel:'Media recente',
                ceilingTooltip:'Il punteggio di una piattaforma è una media mobile: la media delle recensioni recenti è il valore verso cui tende — ed è anche il riferimento con cui si giudica se il punteggio è stabile o sotto pressione. Con l\'attuale qualità delle recensioni il punteggio si ferma qui — per superare questa linea servono recensioni migliori, non più numerose.',
                beyondCeilingHint:'L\'obiettivo supera il limite raggiungibile',
                week:'settimana',
                weeks:'settimane',
                year:'anno',
                moreThanDuration:'più di {duration}',
                // ── Modello a quattro scenari: stato / soglia teorica / tempo realistico ──
                badgeHealthy:'Stabile',
                badgeAtRisk:'Sotto pressione',
                badgeUnknown:'Dati insufficienti',
                maintainHealthy:'{score} si mantiene stabile',
                maintainAtRisk:'{score} potrebbe scendere a {ceiling}',
                maintainAtRiskNoCeiling:'{score} potrebbe essere difficile da mantenere',
                maintainUnknown:'Non è ancora possibile valutare la stabilità del punteggio',
                stabilityLabel:'Stabilità del punteggio',
                cannotAssessYet:'Non ancora valutabile',
                barToTarget:'Per arrivare a {target}: circa {count} recensione al massimo punteggio | Per arrivare a {target}: circa {count} recensioni al massimo punteggio',
                barNearMax:'Già vicino al massimo',
                barUnavailable:'Stima non disponibile',
                timeExpected:'Circa {duration}',
                timeMoreThan:'Più di {duration}',
                timeNoData:'Stima del tempo non disponibile',
                timeUnreachableAtAverage:'Non raggiungibile con la media attuale',
                requiredAvgNote:'Le nuove recensioni dovranno avere una media superiore a {required}',
            },
        },
        Performance_Analytics:{
            title:"2. Analisi delle prestazioni",
            tooltip1:'Questa sezione verrà aggiornata giornalmente',
            title1:"Prestazioni complessive",
            text1:'Personalizza KPI',
            label1:"Top 5 punti di forza",
            label2:"Top 5 aree di miglioramento",
            label3:"Paese",
            label4:"Tipo di viaggiatore",
            card1:"Comfort della stanza",
            card2:"Pulizia",
            tooltip2:'Seleziona un intervallo di tempo o una frequenza diversa',
            tooltip3:'Nessun dato disponibile sulle aree di miglioramento',
            text2:'Prestazioni',
            eye_tooltip:{
                Positive:'Positivo',
                Neutral:'Neutrale',
                Negative:'Negativo',
                ReviewsBySubcategory:'Recensioni per sottocategoria',
            },
        }
    },
    ReviewsTitle:{
        // WTK-727: publish a reply on Google
        PostToGoogle: "Pubblica su Google",
        PostToGoogleConfirm: "Questa risposta sarà pubblicata su Google come risposta pubblica della tua attività a questa recensione. Pubblicarla ora?",
        PostToGoogleConfirmButton: "Pubblica",
        PostToGoogleCancel: "Annulla",
        PostedToGoogle: "Risposta pubblicata su Google",
        PostToGoogleFailed: "Impossibile pubblicare la risposta su Google",
        // WTK-730: preview before posting, edit a reply on Google
        EditOnGoogle: "Modifica su Google",
        UpdateOnGoogleConfirm: "Il testo qui sotto sostituirà la tua risposta attuale su Google. Salvarla ora?",
        SaveToGoogle: "Salva su Google",
        UpdatedOnGoogle: "Risposta aggiornata su Google",
        // WTK-820: who replied from WhereToKnow
        ReplyLogPosted: "{name} ha pubblicato questa risposta su Google da WhereToKnow · {time}",
        ReplyLogEdited: "{name} ha modificato la risposta su Google da WhereToKnow · {time}",
        ReplyLogFailed: "{name} ha provato a pubblicare su Google, senza riuscirci · {time}",
        ReplyLogShow: "Cronologia ({n})",
        ReplyLogHide: "Nascondi cronologia",
        ReplyLogSomeone: "Un collega",
        // WTK-743: reply on Tripadvisor through its Management Center
        ReplyOnTripadvisor: "Rispondi su Tripadvisor",
        TripadvisorReplyCopied: "Risposta copiata. Incollala nella pagina Tripadvisor che si è aperta e inviala da lì, con l'account del gestore della struttura. Tripadvisor verifica le risposte prima di pubblicarle.",
        TripadvisorReplyCopyFailed: "Tripadvisor è stato aperto, ma la risposta non è stata copiata. Copiala da qui.",
        title:'Recensioni e Risposte',
        avgResponseTime:"tempo medio di risposta",
        Unreplied:"Non risposto:",
        Flagged:"Marcato:",
        ScoreColorGuide:'Guida ai colori dei punteggi',
        Business_Traveller:'Viaggiatore d\'affari',
        placeholder1:"Seleziona lingua",
        Translation:"Traduzione",
        Translating:"Traducendo",
        Original:"Originale",
        GuestUser:"Utente ospite",
        Stay:"Permanenza:",
        Review:"Recensione:",
        GoToTheReview:"Vai alla recensione",
        Search_Match_Count:"{count} recensioni corrispondenti",
        Search_Match_Summary:"{mentions} in {reviews}",
        Search_Mentions_Count:"{n} menzione | {n} menzioni",
        Search_Reviews_Count:"{n} recensione | {n} recensioni",
        Search_Sort_Mentions:"Menzioni",
        Search_Sort_Mention_Asc:"Menzioni: crescente",
        Search_Sort_Mention_Desc:"Menzioni: decrescente",
        Search_Sort_Default:"Ordinamento predefinito",
        Review_Keyword_Mentioned:"Menzionato {count} volte in questa recensione",
        ReadMore:"Leggi di più",
        ShowLess:"Mostra meno",
        text4:"Proporzione di tipi",
        text5:"Risposta AI",
        text6:"Genera",
        text7:"Modifica",
        text8:"Invia",
        Reply:'Rispondi',
        Copy:'Copia',
        Replied:'Risposto',
        Reply_pending_tooltip:'Potrai rispondere al termine dell\'analisi di questa recensione',
        Forward:'Inoltra',
        ForwardTo:'Inoltra a',
        ForwardCancel:'Annulla',
        ForwardSend:'Invia',
        ForwardNoStaff:'Nessun membro del personale',
        ForwardNoPermission:'Non hai accesso all\'elenco del personale. Chiedi a un amministratore della struttura.',
        ForwardUseWtk:'Invia tramite WTK',
        ForwardNotePlaceholder:"Spiega perché stai inoltrando questa recensione a un collega… (facoltativo)",
        ForwardSendViaWtk:'Invia tramite WTK',
        ForwardSending:'Invio in corso…',
        ForwardSent:'Inviato tramite WTK',
        filters:{
            title:'Filtri',
            Review_Mode:'Modalità di recensione',
            Review_Mode1:'Punteggio dell\'ospite',
            Score_Scale_Note:'Scala da 10 punti. I punteggi delle piattaforme a 5 stelle sono raddoppiati (5★ = 10).',
            Review_Mode2:'Analisi AI',
            Review_ModeNote:'Nota informativa',
            Review_ModeNote1:'Mostra solo i commenti con contenuto testuale',
            Review_ModeNote2:'(i commenti senza testo sono stati nascosti)',
            Review_Type:'Tipo di recensione',
            Review_Type1:'Tutte le recensioni',
            Review_Type2:'Con testo',
            Review_Type3:'Solo valutazioni',
            Review_Type1_disabled:'Non disponibile in modalità "Solo testo".',
            Sentiment_Status:'Stato del sentiment',
            Source_Language:'Lingua della recensione',
            Source_Language_Placeholder:'Tutte le lingue',
            Summary_Type:'Tipo di riepilogo',
            Summary_TypeObj:{
                IncludePositive:'Include positivi',
                IncludeNegative:'Include negativi',
                PositiveOnly:'Solo positivi',
                NegativeOnly:'Solo negativi',
            },
            Review_Status:'Stato recensione',
            Review_StatusLabels:[
                {
                    label:'Positivo',
                    value:'Positive',
                },
                {
                    label:'Negativo',
                    value:'Negative',
                },
                {
                    label:'Discrepanza punteggio',
                    value:'RatingDiscrepancy',
                },
            ],
            Categories:'Categorie',
            Sort:'Ordina',
            Sort_By:'Ordina per',
            Sort_Time:'Tempo',
            Sort_Score:'Punteggio',
            Sort_Weight:'Peso',
            Sort_Time_Newest:'Più recenti',
            Sort_Time_Oldest:'Più vecchi',
            Sort_Score_High:'Alto a basso',
            Sort_Score_Low:'Basso ad alto',
            Sort_Weight_Highest:'Peso più alto',
            sortObj:{
                'Time (newest first)':'Tempo（più recente prima）',
                'Time (oldest first)':'Tempo（più vecchio prima）',
                'Score (high to low)':'Punteggio（dal più alto al più basso）',
                'Score (low to high)':'Punteggio（dal più basso al più alto）',
                'Weight (highest first)':'Peso（dal più alto al più basso）',
            },
            Reply_Status:'Stato della risposta',
            Reply_StatusObj:{
                'Replied':'Risposto',
                'Pending':'Non risposto',
            },
            Apply:'Applica',
            Cancel:'Annulla',
        },
        noReviews1:'Non ci sono recensioni per il periodo/ fonte selezionato, resetta il',
        noReviews2:'filtro e riprova',
        WTKscore:'WQI:',
        WTKscore1:'calcolato basandosi su un avanzato analisi del sentiment AI e contributi da esperti di hotel, con una scala da 1 a 10. Per le fonti che usano originariamente una scala da 1 a 5 (come Google), i punteggi sono stati convertiti in una scala da 1 a 10 per garantire una comparabilità公平 across all platforms.',
        Note:"Nota",
        NoteText:"Questa recensione non ha feedback scritto. La risposta è generata esclusivamente basandosi sul punteggio e quindi potrebbe essere più generica",

        Summary:'Sintesi',
        LoadTheCommentData:'Carica i dati dei commenti',
        CategoryWeight:'Peso della categoria',
        CopyAllSections:'Copia tutte le sezioni',
        showTranslatedContent:"Nessun dato di traduzione per la risposta corrente. Clicca per tradurre più tardi.",
        showOriginalContent:'La risposta corrente non ha dati "Originali". Clicca per tradurre.',
        Export_Excel:'Esporta Excel',
        // WTK-573 筛选栏图标说明 / 重置按钮
        Filters_Tip:'Filtri',
        Filters_Active_Tip:'Filtri (attivi)',
        Search_Tip:'Cerca',
        Reset_Filters:'Reimposta',
        Keyword_Search_Placeholder:'Cerca nel testo delle recensioni…',

    },
    Replies:{
        title:'Impostazione risposta',
        Hotel_Name_Usage:{
            title:'Uso del nome dell\'hotel',
            title1:'Nome dell\'hotel',
            input1:'Inserisci il nome dell\'hotel',
        },
        Restaurant_Name_Usage:{
            title:'Utilizzo nome ristorante',
            title1:'Nome ristorante',
            input1:'Inserisci il nome del ristorante',
        },
        Tone:{
            title:'Tono',
            label1:'Preimpostazione marca',
            label2:'Formalità',
            label3:'Contrazioni',
            label4:'Emoji',
            label5:'Umore',
            label6:'Limite di punti esclamativi',
            label7:'Usa il nome dell\'hotel',
            label7_restaurant:'Usa il nome del ristorante',
            option1:[
                {
                    label:'Elegante formale',
                    value:'formal_elegant',
                },
                {
                    label:'Premium calorico',
                    value:'premium_warm',
                },
                {
                    label:'Casuale giocoso',
                    value:'casual_playful',
                },
                {
                    label:'Minimale neutrale',
                    value:'minimal_neutral',
                },
            ],
            option2:[
                {
                    label:'Medio',
                    value:'medium'
                },
                {
                    label:'Alto',
                    value:'high'
                },
            ],
            option3:[
                {
                    label:'Basso',
                    value:'low'
                },
                {
                    label:'Medio',
                    value:'medium'
                },
            ],
            showData1:[
                'Basso: “Grazie per il tuo feedback! Siamo contenti che hai apprezzato il tuo soggiorno.”',
                'Medio: “Grazie per il tuo feedback. Siamo lieti di sapere che hai apprezzato il tuo soggiorno con noi.”',
                'Alto: “Ringraziamo sinceramente per il tuo prezioso feedback e siamo lieti che il tuo soggiorno sia stato piacevole.”'
            ],
            showData2:'Io sono, Sono',
            showData3:'Controllare l\'intensità del senso dell\'umorismo',
            showData4:'Numero massimo di punti esclamativi consentiti',
            showData5:'Includere il nome dell\'hotel nelle risposte (attivo) o meno (disattivo)',
        },
        LanguageRules:{
            title:'Regole linguistiche',
            label1:'Preferenza di lingua',
            label2:'Stile di pronome',
            radio1:[
                {
                    text1:'Auto',
                    text2:'（Segue automaticamente la lingua dei commenti dell\'ospite）',
                    value:'auto'
                },
                {
                    text1:'Fisso',
                    text2:'（Risponde sempre nella lingua specificata）',
                    value:'fixed'
                },
            ],
            option1:[
                {
                    label:'Formale',
                    value:'formal'
                },
                {
                    label:'Informale',
                    value:'informal'
                },
            ],
            alertTitle:'Nota',
            alertData:'Se selezioni "Designazione obbligatoria", le risposte saranno sempre generate nella lingua scelta, anche se l\'ospite ha scritto la sua recensione in un\'altra lingua. Ciò potrebbe sembrare inconsistente.',
            showData1:'Disponibile solo in lingue con pronomi formali/informali (tedesco, francese, italiano, cinese)',
        },
        WordPreferences:{
            title:'Preferenze di parole',
            label1:'Parole preferite',
            label2:'Parole da evitare',
            tagInput1:['Team','Esperienza'],
            tagInput2:['Patronato','Di conseguenza'],
        },
        Title:{
            title:'Titolo',
            label1:'Stile di saluto',
            label2:'Saluto predefinito',
            option1:[
                {
                    label:'Ciao [Nome utente]',
                    value:'Hi [Username]',
                },
                {
                    label:'Hello [Nome utente]',
                    value:'Hello [Username]',
                },
                {
                    label:'Caro [Nome utente]',
                    value:'Dear [Username]',
                },
                {
                    label:'Personalizzato',
                    value:'Custom',
                },
            ],
            option2:[
                {
                    label:'Caro Ospite',
                    value:'Dear Guest',
                },
                {
                    label:'Ciao Viaggiatore',
                    value:'Hello Traveler',
                },
                {
                    label:'Personalizzato',
                    value:'Custom',
                },
            ],
        },
        MainBody:{
            title:'Corpo principale',
            title1:'Risposte intelligenti',
            label1:'Testo',
            label2:'Categoria',
            label3:'Argomento',
            label4:'Parole chiave trigger',
            label5:'Azioni',
            button1:'Aggiungi nota',
            emptyText:'+ Aggiungi la tua prima nota intelligente',
            showData1:'Le note saranno triggerate automaticamente basandosi su corrispondenze di parole chiave e semantiche, e ogni nota apparirà solo una volta.',

            placeholder3:"Crea nuovo argomento",
            placeholder4:"Cerca o aggiungi opzioni",
            placeholder5:"+aggiungi",
        },
        Ending:{
            title:'Conclusione',
            label1:'Politica di invito a tornare',
            label2:'Firma',
            radio1:[
                {
                    text1:'Invita sempre a tornare',
                    text2:'Ogni risposta include un invito a tornare',
                    value:"always_invite_back"
                },
                {
                    text1:'Invita su feedback positivo o misto',
                    text2:'Invita solo quando il commento dell\'ospite è positivo o neutrale',
                    value:"invite_on_positive_or_mixed_feedback"
                },
                {
                    text1:'Invito intelligente (decide l\'AI)',
                    text2:'L\'AI deciderà; nessun invito in casi chiaramente negativi',
                    value:"smart_invite"
                },
            ],
            placeholder1:"Aggiungi qui il nome del tuo team o del manager",
            placeholder2:'"Il Team Relazioni con gli Ospiti", "Il tuo Hotel di Londra"',
        },
        ReplyLength:{
            title:'Lunghezza della risposta',
            radio1:[
                {
                    text1:'Corta (30-60 parole)',
                    text2:' (Veloce e semplice: adatto per piattaforme OTA)',
                    value:"short",
                },
                {
                    text1:'Standard (60-100 parole)',
                    text2:'(Bilanciato e professionale: consigliato per impostazione predefinita)',
                    value:"standard",
                },
                {
                    text1:'Dettagliata (100-140 parole)',
                    text2:'(Più completa e narrativa; ideale per siti ufficiali o risposte email)',
                    value:"detailed",
                    showTooltip: true
                },
                {
                    text1:'Dinamica (l\'AI si adatta automaticamente)',
                    text2:' (Lunghezza flessibile; si adatta alla recensione dell\'ospite)',
                    value:"dynamic",
                },
            ],
        },
        button1:'Anteprima',
        button2:'Salva impostazioni',
        Preview:{
            title:'Anteprima',
            label1:"Titolo",
            label2:"Inizio",
            label3:"Corpo principale",
            label4:"Conclusione",
            button1:'annulla',
            button2:'conferma',
        },
        Reply_Saved:'Risposta salvata',
        Reply_Saved_text:'La tua risposta è stata salvata. La troverai nella sezione Libreria risposte.',
    },
    competitors:{
        title:'Concorrenti',
        title1:'Hotel selezionati：',
        title2:'Punteggio medio delle piattaforme OTA',
        title3:'Hotel complessivo',
        label3_1:'Il tuo hotel complessivo',
        label3_1_restaurant:'Il tuo ristorante complessivo',

        title4:'Concorrente',
        title5:'Panoramica dei punteggi',
        label5_1:'Punteggio totale',
        label5_2:'Pulizia',
        label5_3:'Dotazioni e Comfort della Stanza',
        label5_4:'Posizione e Quartiere',
        label5_5:'Esperienza dell\'Ospite e Servizio',
        label5_6:'Servizi e Atmosfera dell\'Hotel',
        label5_7:'Cibo e Bevande',
        label5_8:'Rapporto Qualità-Prezzo',

        title6:'Categoria:',
        lowSampleTooltip:'Campione ridotto (n={n}) — solo indicativo, non statisticamente affidabile',
        compareLabel:'Periodo di confronto',
        compareStartPlaceholder:'Data inizio',
        compareEndPlaceholder:'Data fine',
        compareVs:'vs',
        compareSamePeriodHint:'Seleziona un periodo diverso',
        viewPrevPeriodReviews:'Visualizza recensioni del periodo di confronto',
        compare:'Confronta',
        bySentiment:'Per sentimento',
        byCategory:'Per categoria',
        topic:'Argomento',
        review:'Recensione',
        byTopic:'Per argomento',
        byNumber:'Per numero',
        period:'Periodo',
        previousValueLabel:'Periodo di confronto',
        currentValueLabel:'Periodo attuale',
        changeLabel:'Variazione',
        wow:{
          title:'Variazioni settimana su settimana',
          tooltip:'Confronta il periodo corrente con il periodo precedente di pari durata. Gli hotel con campione < 10 mostrano la variazione in stile attenuato — da interpretare solo come indicazione di tendenza.',
          colHotel:'Hotel',
          colRestaurant:'Ristorante',
          lastWeek:'Settimana scorsa',
          thisWeek:'Questa settimana',
          change:'Variazione',
          you:'Tu',
          lowSample:'Campione ridotto (n={n}) — variazione solo indicativa',
        },
        title7:'Sintesi',
        label7_1:'Miglioramento',
        label7_2:'Suggerimento',
        label7_3:'Problema',

        title8:'Percorso del cliente',
        Sentiment_Evolution:'Andamento del punteggio',
        ScoreTrend_Compare:'Confronta',
        ScoreTrend_None:'Nessuno',
        ScoreTrend_PreviousPeriod:'Periodo precedente',
        ScoreTrend_LastMonth:'Mese scorso',
        ScoreTrend_SamePeriodLastYear:"Stesso periodo dell'anno scorso",
        ScoreTrend_CustomRange:'Intervallo personalizzato',
        ScoreTrend_CurrentRange:'Intervallo corrente',
        ScoreTrend_CompareRange:'Intervallo di confronto',
        ScoreTrend_Current:'Corrente',
        ScoreTrend_CompareSeries:'Confronto',
        ScoreTrend_ScoreBelowThreshold:'Punteggio < soglia',
        ScoreTrend_CurrentAvg:'Media attuale',
        ScoreTrend_CompareAvg:'Media di confronto',
        ScoreTrend_Difference:'Differenza',
        ScoreTrend_PercentChange:'Variazione percentuale',
        ScoreTrend_NoComparisonData:'Nessun dato di confronto',
        ScoreTrend_VsPreviousPeriod:'vs periodo precedente',
        ScoreTrend_VsLastMonth:'vs mese scorso',
        ScoreTrend_VsLastYear:'vs anno scorso',
        ScoreTrend_VsCustomRange:'vs intervallo personalizzato',
        ScoreTrend_LastMonthNote:'Media sull\'intero mese solare; il grafico mostra solo i giorni sovrapposti.',
        ScoreTrend_Apply:'Applica',
        ScoreTrend_Back:'Indietro',
        title9:'Panoramica delle recensioni per fonte',
        label9_1:'Social media',
        label9_2:'Modalità anteprima',

        title10:'Piattaforma di social media',
        label10_1:'Impegno totale',
        title11:'Paesi',
        title12:'Tipo di viaggiatore',
        // 评论证据抽屉（CompetitorCategoryDrawer）里按大类分组的短名
        topicShort:{
            Location:'Posizione',
            Cleanliness:'Pulizia',
            Room:'Camera',
            Atmosphere:'Atmosfera',
            FB:'F & B',
            Service:'Servizio',
            Value:'Rapporto qualità-prezzo',
            Other:'Altro',
        },
    },
    StaffManagement:{
        title:'Gestione del personale',
        addStaff:'Aggiungi personale',
        email:'Email',
        username:'Nome utente',
        name:'Nome',
        role:'Ruolo',
        status:'Stato',
        actions:'Azioni',
        editRoles:'Modifica ruoli',
        edit:'Modifica',
        // 手机列表「更多」菜单：只能查看的账号（集团账号、自己）用这个代替「编辑」
        viewDetails:'Visualizza dettagli',
        department:'Reparto',
        departmentPlaceholder:'Seleziona un reparto',
        allDepartments:'Tutti i reparti',
        post:'Posizione',
        postPlaceholder:'Inserisci la posizione (es. Front Office Manager)',
        suspend:'Sospendi',
        delete:'Elimina',
        active:'Attivo',
        suspended:'Sospeso',
        confirmSuspendTitle:'Sospendere questo membro del personale?',
        confirmSuspendBody:'Non potrà più accedere. Puoi riattivarlo in qualsiasi momento.',
        confirmDeleteTitle:'Rimuovere da questa struttura?',
        confirmDeleteBody:'Perderà l\'accesso a questa struttura. Questa azione non può essere annullata.',
        cancel:'Annulla',
        confirm:'Conferma',
        save:'Salva',
        emailPlaceholder:'es. nome@tuohotel.it',
        rolesPlaceholder:'Seleziona ruolo/i',
        searchPlaceholder:'Cerca nome, email o ruolo',
        statusAll:'Tutti',
        noStaff:'Nessun membro del personale',
        addSuccess:'Aggiunto con successo',
        suspendSuccess:'Sospeso',
        deleteSuccess:'Rimosso',
        rolesUpdateSuccess:'Ruoli aggiornati',
        loadFailed:'Caricamento non riuscito. Riprova.',
        emailRequired:'Inserisci un\'email',
        invalidEmail:'Inserisci un indirizzo email valido, es. nome@tuohotel.it',
        emailExists:'Questa email è già nell\'elenco del personale',
        addFailed:'Impossibile aggiungere il membro del personale. Riprova.',
        actionFailed:'Si è verificato un errore. Riprova.',
        currentUser:'Accesso come',
        you:'Io',
        cannotChangeSelf:'Non puoi modificare, sospendere o eliminare il tuo account',
        lastAdmin:'Deve restare almeno un amministratore attivo',
        noPermissionTitle:'Solo gli amministratori possono gestire il personale',
        noPermissionDesc:'Chiedi a un amministratore della struttura di aggiungere o modificare il personale.',
        updateSuccess:'Salvato',
        rolesRequired:'Seleziona un ruolo',
        staffTitle:'Personale',
        peopleCount:'{n} persona | {n} persone',
        inviteStaff:'Invita personale',
        sendInvite:'Invia invito',
        saveChanges:'Salva modifiche',
        close:'Chiudi',
        removeFromProperty:'Rimuovi dalla struttura',
        permissionsCount:'{n} autorizzazioni',
        whatRoleCanDo:'Cosa può fare {role}',
        compareRoles:'Confronta ruoli',
        currentRole:'Ruolo attuale: {role}. Scegli un ruolo qui sopra per cambiarlo.',
        noRoles:'Nessun ruolo disponibile',
        rolesTitle:'Ruoli e autorizzazioni',
        rolesIntro:'Cosa può fare ogni ruolo in questa struttura.',
        permissionsIncluded:'Autorizzazioni incluse',
        included:'Incluso',
        notIncluded:'Non incluso',
        scope:'Ambito',
        lastLogin:'Ultimo accesso',
        scopeProperty:'Questa struttura',
        scopeBrand:'Brand',
        scopePortfolio:'Portfolio',
        groupTag:'Gruppo',
        groupCount:'{n} account di gruppo',
        groupNote:'Gli account di gruppo coprono più strutture. Sono configurati da Where to know e qui sono di sola lettura.',
        // 集团账号详情抽屉（只读）
        accessibleProperties:'Strutture accessibili',
        propertyCount:'{n} struttura | {n} strutture',
        propertyListPending:'L\'elenco delle strutture non è ancora disponibile.',
        neverActive:'Mai',
        // 同一组几个权限之间的分隔符
        listSeparator:', ',
        // 权限显示名，键是权限代码（后端 labelEn / labelZh 是技术名，这里写给酒店用户看的说法）
        perm:{
            READ_DASHBOARD:'Visualizza panoramica',
            READ_REVIEW:'Visualizza recensioni',
            READ_NEED_ATTENTION:'Visualizza casi',
            MANAGE_NEED_ATTENTION:'Gestisci casi',
            READ_REPLY_LIBRARY:'Visualizza libreria risposte',
            MANAGE_REPLY_LIBRARY:'Modifica libreria risposte',
            READ_REPLY:'Visualizza impostazioni risposte',
            MANAGE_REPLY:'Modifica impostazioni risposte',
            READ_COMPETITORS:'Panoramica concorrenza',
            READ_COMPETITORS_REVIEW:'Recensioni dei concorrenti',
            READ_REPORT:'Visualizza report',
            EXPORT_REPORT:'Scarica report PDF',
            EXPORT_REPORT_EXCEL:'Esporta dati (Excel)',
            READ_SURVEY:'Visualizza sondaggi',
            MANAGE_SURVEY:'Gestisci sondaggi',
            AI_CHAT:'Chat AI',
            READ_GOAL:'Visualizza obiettivi',
            MANAGE_GOAL:'Modifica obiettivi',
            MANAGE_OVERALL_SETTING:'Notifiche',
            WEBSITE_WIDGET:'Widget del sito',
            READ_STAFF:'Visualizza personale',
            MANAGE_STAFF:'Gestione del personale',
            MANAGE_DEPT:'Gestione dei reparti',
        },
        // 角色名，键是角色代码 _STAFF_ 后面那段（德 / 意界面也用英文名）
        roleName:{
            ADMIN:'Admin',
            MANAGER:'Manager',
            GUEST_RELATIONS:'Guest Relations',
            VIEWER:'Viewer',
        },
        // 角色说明（后端 description 只有英文），键是角色代码 _STAFF_ 后面那段
        roleDesc:{
            ADMIN:'Accesso completo, incluso personale, connessioni alle piattaforme e widget del sito.',
            MANAGER:'Tutti i dati e le impostazioni operative. Non può gestire personale o connessioni.',
            GUEST_RELATIONS:'Gestisce ogni giorno recensioni, casi e sondaggi.',
            VIEWER:'Solo visualizzazione. Può scaricare i report, ma non modificare o esportare dati.',
        },
        // 权限分组（/staff/roles 的 groupName）的显示名
        groups:{
            Overview:'Panoramica',
            Reviews:'Recensioni',
            Cases:'Casi',
            Replies:'Impostazioni risposte',
            Competition:'Concorrenza',
            Reports:'Report',
            Surveys:'Sondaggi',
            Other:'Intelligence',
            Goals:'Obiettivi',
            Settings:'Impostazioni',
            Staff:'Personale',
        },
    },
    Departments:{
        title:'Reparti',
        addDepartment:'Aggiungi reparto',
        editDepartment:'Modifica reparto',
        addSub:'Aggiungi sottoreparto',
        edit:'Modifica',
        delete:'Elimina',
        name:'Nome reparto',
        namePlaceholder:'Inserisci il nome del reparto',
        parent:'Reparto superiore',
        topLevel:'Nessuno (livello principale)',
        manager:'Responsabile',
        managerPlaceholder:'Seleziona un responsabile',
        updatedBy:'Ultima modifica di',
        actions:'Azioni',
        noDepartments:'Nessun reparto',
        cancel:'Annulla',
        confirm:'Conferma',
        save:'Salva',
        confirmDeleteTitle:'Eliminare questo reparto?',
        confirmDeleteBody:'Questa azione non può essere annullata.',
        confirmDeleteBodyWithChildren:'Questo reparto ha dei sottoreparti. L\'eliminazione non può essere annullata.',
        addSuccess:'Reparto aggiunto',
        updateSuccess:'Reparto aggiornato',
        deleteSuccess:'Reparto eliminato',
        loadFailed:'Caricamento non riuscito. Riprova.',
        saveFailed:'Operazione non riuscita. Riprova.',
        nameRequired:'Inserisci il nome del reparto',
    },
    Settings:{
        title:'Impostazioni',
        left1:'Utente',
        left2:'Obiettivi',
        left3:'Notifiche',
        left4:'Widget',
        left5:'Connessioni',
        left6:'Personale',
        left7:'Reparti',
        left8:'Ruoli e autorizzazioni',
        left9:'Temi in evidenza',
        teamGroup:'Team',
        Widget:{
            title:'Widget Recensioni',
            desc:'Incorpora i tuoi punteggi WTK su qualsiasi sito web. Basta incollare un tag script.',
            activeWidgets:'Widget attivi',
            createNew:'Crea nuovo widget',
            style:'Stile',
            styleCompact:'Piè di pagina / badge',
            styleHorizontal:'Striscia hero',
            styleCard:'Tutte le categorie',
            styleDark:'Sovrapposizione scura',
            period:'Periodo recensioni',
            period3m:'Ultimi 3 mesi',
            period12m:'Ultimi 12 mesi',
            periodAll:'Tutti i tempi',
            brandColor:'Colore brand',
            custom:'Colore personalizzato',
            domains:'Domini consentiti',
            domainsHint:'Lascia vuoto per consentire tutti i domini.',
            domainsPlaceholder:'es. tuohotel.it',
            generate:'Genera codice embed',
            readyTitle:'Widget pronto',
            readyDesc:'Copia il codice qui sotto e incollalo nel <body> del tuo sito.',
            copy:'Copia codice',
            copied:'Copiato!',
            revoke:'Revoca',
            revokeConfirm:'Revocare questo widget? I clienti che usano questo codice non vedranno più il widget.',
            revokeSuccess:'Widget revocato.',
            createError:'Creazione fallita. Riprova.',
            createdAt:'Creato il',
            platformScores:'Punteggi piattaforme (OTA)',
            platformScoresHint:'Seleziona le piattaforme da mostrare nel widget.',
            categories:'Categorie',
            categoriesHint:'Seleziona le categorie da mostrare. Lascia vuoto per mostrarle tutte.',
            livePreview:'Anteprima live',
            previewNote:'Punteggi di esempio – i dati reali riflettono il tuo hotel',
            selectAll:'Seleziona tutto',
            clearAll:'Cancella',
            noHotel:"Seleziona prima un hotel.",
        },
        User:{
            label1:'Dettagli di accesso',
            label2:'Cambia password',
            label3:'Password corrente',
            label4:'Nuova password',
            label5:'Conferma nuova password',
            prompt1:'Requisiti per la password：',
            prompt2:'assicurati che sia lunga almeno 8 caratteri ',
            prompt3:'deve includere un numero, una lettera maiuscola e una lettera minuscola.',
            button1:'Cambia password',
        },
        Goals:{
            title:'Obiettivi',
            label1:'Categoria',
            label2:'Punteggio',
            label3:'Obiettivo',
            label4:'Differenza',
            label5:'Scadenza',
            label6:'Conto alla rovescia',
            days:"giorni",
            notSet:"Non impostato",
            setGoal:"Imposta obiettivo",
            clearGoal:"Rimuovi",
            // 手机宽度紧凑表格：目标值单元格「设置」、编辑行的「保存」
            set:"Imposta",
            save:"Salva",
            goalReference:"Valore di riferimento: {value}",
        },
        Notifications:{
            title:'Notifiche',
            enableLabel:'Abilita notifiche e-mail',
            enableDesc:'Ricevi avvisi e-mail quando vengono attivate le condizioni di recensione selezionate.',
            customAlertTitle:'Avvisi sui temi in evidenza',
            customAlertDesc:'Ricevi un avviso quando una nuova recensione valuta uno dei tuoi temi in evidenza, o un suo sottotema, sotto la soglia. Lascia vuoto per nessun avviso.',
            otaAlertTitle:'Avvisi punteggio OTA',
            otaTitle:'Soglie punteggio OTA',
            otaDesc:'Ricevi un avviso quando il punteggio di una nuova recensione scende sotto la soglia impostata per ciascuna piattaforma.',
            wtkTitle:'Soglia WQI',
            wtkLabel:'WQI',
            categoryTitle:'Soglie punteggio categoria',
            riskSignalTitle:'Avvisi segnali di rischio IA',
            riskSignalDesc:'Ricevi un avviso quando WTK rileva schemi di rischio nascosti che potrebbero non essere evidenti dal solo punteggio OTA.',
            ratingDiscrepancy:'Disallineamento punteggio',
            ratingDiscrepancyDesc:'Avviso quando l\'esperienza dell\'ospite descritta nella recensione non corrisponde al punteggio OTA assegnato.',
            negativeOnly:'Recensione solo negativa',
            negativeOnlyDesc:'Avviso quando una recensione contiene solo sentimenti negativi senza feedback positivi.',
            severeNegative:'Sentimento fortemente negativo',
            severeNegativeDesc:'Avviso quando una recensione contiene un linguaggio fortemente negativo che indica un grave problema nell\'esperienza dell\'ospite.',
            recipientsTitle:'Destinatari notifiche',
            emailTitle:'Destinatari e-mail notifiche',
            emailPlaceholder:'Inserisci indirizzo e-mail',
            addEmail:'Aggiungi e-mail',
            addBtn:'Aggiungi',
            cancelBtn:'Annulla',
            reportRecipientsTitle:'Destinatari dei report',
            reportEmailTitle:'Destinatari e-mail dei report',
            reportEmailDesc:'Scegli chi riceve i tuoi report periodici sulle prestazioni.',
            selectFromStaff:'Seleziona dal personale',
            noStaff:'Nessun membro del personale',
        },
        // WTK-1019 专属关注：从话题库选；homeCta 是首页没有专属关注时那张卡片的入口
        FocusTopics:{
            title:'Temi in evidenza',
            intro:'Scegli dalla libreria di temi di Where to Know i temi che vuoi seguire da vicino. Un tema scelto diventa uno dei tuoi temi in evidenza nella Home e in obiettivi, avvisi e filtri.',
            noteFromToday:'Un tema scelto viene analizzato nelle nuove recensioni da oggi in poi; le recensioni precedenti non vengono analizzate.',
            noteUnpick:'Se deselezioni un tema, non viene più analizzato; i risultati ottenuti finora restano.',
            notePlaces:'Un hotel può avere fino a {max} temi in evidenza. Anche i temi in evidenza impostati per te da Where to Know occupano un posto.',
            libraryLabel:'Libreria di temi',
            placesLeft:'{n} posto libero | {n} posti liberi',
            noPlaceTip:'Nessun posto libero. Deseleziona prima un tema per scegliere questo.',
            anchorSub:'Estende {category} › {sub}',
            anchorCategory:'Estende {category}',
            emptyTitle:'La libreria non contiene ancora temi',
            emptyDesc:'Where to Know sta preparando la libreria di temi. I nuovi temi compariranno qui.',
            loadFailed:'Impossibile caricare la libreria di temi',
            retry:'Riprova',
            noPermission:'Non hai il permesso di vedere la libreria di temi',
            noPermissionSave:"Non hai il permesso di modificare i temi in evidenza. Rivolgiti all'amministratore dell'hotel.",
            saveRefused:'Impossibile salvare: potrebbero non esserci posti liberi, oppure un tema non è più nella libreria. La pagina ora mostra lo stato attuale.',
            saveFailed:'Salvataggio non riuscito. Riprova più tardi.',
            homeCta:'Scegli i temi in evidenza',
        },
    },
    Reports: {
        Lang_Fallback:'Questo hotel non ha ancora un report in {want}, quindi viene mostrato in {shown}.',
        Export_Pdf_Generating:'Il report di questo periodo è ancora in preparazione. Riprova tra qualche minuto.',
        Export_Pdf_Unavailable:'Al momento non è possibile generare il PDF di questo periodo. Riprova più tardi.',
        MoM: {
            title: 'Monitoraggio mese su mese',
            lastMonth: 'Mese scorso',
            thisMonth: 'Questo mese',
            monitorClosely: 'Monitorare da vicino',
            badge_new: 'Nuovo',
            badge_resolved: 'Segnale ripulito',
            badge_recurring: 'Ricorrente',
            month_apr: 'Apr',
            month_mar: 'Mar',
            tracking_mock_1: 'Il tè pomeridiano descritto come nella media; gli ospiti si aspettavano un segnale premium più chiaro rispetto al prezzo.',
            tracking_mock_2: 'Accoglienza in reception incoerente nelle finestre di picco del check-in.',
            tracking_mock_3: 'Posti all\'aperto o semi-aperti talvolta disturbati da rumore o correnti — il sentiment è migliorato dopo cartellonistica e ritocchi al layout.',
            tracking_mock_4: 'Segnalazione isolata di ritardo su asporto prepagato — lacuna operativa una tantum, non un pattern ricorrente.',
            action_title: 'Monitoraggio risoluzione azioni',
            col_current_signal: 'Segnale attuale',
            col_last_action: 'Azione del mese scorso',
            effective: 'Efficace',
            low_confidence: 'bassa confidenza',
            confidence_medium: 'confidenza media',
            confidence_high: 'alta confidenza',
            empty_column: 'Nessuna voce in questo periodo.',
            empty_solution: 'Nessuna riga di monitoraggio soluzioni.',
            action_signal_1: 'Il problema non compare più nel feedback degli ospiti.',
            action_last_1: 'Incidente isolato — rivedere il flusso asporto e confermare gli SLA di preparazione con il team.',
            action_signal_2: 'Le menzioni positive sono stabili; nessun nuovo cluster negativo nelle recensioni scritte.',
            action_last_2: 'Briefing con F&B su presentazione del tè pomeridiano e tempi tra le portate.',
            hotel_col_recurring: 'Problemi ricorrenti ({n})',
            hotel_col_declined: 'Reclami in calo ({n})',
            hotel_col_new: 'Nuove criticità ({n})',
            hotel_rank_n: 'Rank {n}',
            hotel_mock_breakfast: 'Colazione',
            hotel_mock_restaurant: 'Ristorante',
            hotel_mock_checkin: 'Check-in',
            hotel_mock_elevator: 'Ascensore',
            hotel_mock_billing: 'Fatturazione',
            hotel_mock_price_fit: 'Esperienza vs. prezzo',
            hotel_recurring_b_apr: 'Tempi dei piatti caldi ancora irregolari; code nelle ore di punta.',
            hotel_recurring_b_mar: 'Diversi commenti su ritardi nel rifornimento del buffet.',
            hotel_recurring_r_apr: 'Di nuovo citati i tempi di servizio a cena; rumore vicino alla cucina a vista.',
            hotel_recurring_r_mar: 'Temi simili su passaggio prenotazioni e attesa del tavolo.',
            hotel_declined_ci_mar: 'Meno attriti dopo corsia express dedicata al check-in.',
            hotel_declined_el_mar: 'Rari reclami sui tempi di attesa dopo il fix del contratto di manutenzione.',
            hotel_new_b_apr: 'Nuovo cluster su minibar e voci tassa di soggiorno in conto.',
            hotel_new_p_apr: 'Gli ospiti dubitano che il prodotto camera corrisponda al livello di tariffa.',
            hotel_solution_title: 'Monitoraggio soluzioni',
            hotel_sol_th_category: 'Categoria',
            hotel_sol_th_action: 'Azione e dettagli',
            hotel_sol_th_outcome: 'Esito',
            hotel_not_resolved: 'Non risolto',
            still_observed: 'Ancora osservato',
            failure_type_label: 'Chiave segnale',
            hotel_sol_parent_location: 'Posizione e quartiere',
            hotel_sol_sub_accessibility: 'Accessibilità',
            hotel_sol_1_mar: 'Segnaletica aggiornata all’ingresso; briefing portineria sul accompagnamento.',
            hotel_sol_1_apr: 'Follow-up: meno menzioni su percorsi poco chiari; monitorare transfer aeroporto.',
            hotel_sol_parent_fb: 'F&B',
            hotel_sol_sub_breakfast: 'Operazioni colazione',
            hotel_sol_2_apr: 'Checklist rifornimenti scaglionati; runner aggiuntivo 7–9.',
            hotel_sol_parent_billing: 'Fatturazione e pagamenti',
            hotel_sol_sub_invoice: 'Accuratezza fattura',
            hotel_sol_3_apr: 'Ancora sporadiche contestazioni per addebiti duplicati; finance rivede regole PMS.',
        },
    },
    Connections:{
        title:'Connessioni',
        intro:'Collega il tuo Profilo dell\'attività su Google e la tua scheda Tripadvisor a WhereToKnow.',
        googleDesc:'Accedi con l\'account Google che possiede o gestisce il Profilo dell\'attività di questa struttura, poi scegli la sede.',
        tripadvisorDesc:'Cerca la scheda Tripadvisor di questa struttura o incolla il link della sua pagina Tripadvisor.',
        connected:'Collegato',
        notConnected:'Non collegato',
        needsReconnect:'Da ricollegare',
        chooseLocationStatus:'Scegli la sede',
        unavailable:'Non ancora disponibile',
        connectGoogle:'Collega Google',
        reconnect:'Ricollega',
        chooseLocation:'Scegli la sede',
        changeLocation:'Cambia sede',
        connectTripadvisor:'Collega Tripadvisor',
        changeListing:'Cambia scheda',
        disconnect:'Scollega',
        viewListing:'Vedi la scheda',
        signedInAs:'Accesso effettuato come {email}',
        chooseGoogleLocation:'Scegli la sede Google',
        chooseGoogleLocationHint:'Queste sono le sedi del Profilo dell\'attività gestite dal tuo account Google.',
        noGoogleLocations:'Questo account Google non gestisce alcuna sede. Ricollegati con l\'account che la possiede o la gestisce.',
        searchTripadvisor:'Cerca su Tripadvisor',
        searchPlaceholder:'Nome della struttura',
        search:'Cerca',
        noResults:'Nessuna scheda trovata. Prova un altro nome o incolla il link qui sotto.',
        orPasteLink:'Oppure incolla il link della tua pagina Tripadvisor',
        connect:'Collega',
        cancel:'Annulla',
        save:'Salva',
        disconnectTitle:'Scollegare {platform}?',
        disconnectBody:'WhereToKnow smetterà di usare questa connessione. Puoi ricollegarti in qualsiasi momento.',
        connectedToast:'{platform} collegato',
        failed:'Qualcosa è andato storto. Riprova.',
        notEnabled:'Le connessioni non sono ancora attive per questa struttura. Contattaci per attivarle.',
        notForBrand:'Seleziona un hotel o un ristorante per gestirne le connessioni.',
        finishingGoogle:'Completamento della connessione Google…',
        backToConnections:'Torna a Connessioni',
        connectAgain:'Ricollega Google',
        tripadvisorFromProfile: "Questa è la pagina Tripadvisor da cui raccogliamo le recensioni di questa struttura. Puoi sceglierne un'altra qui: WhereToKnow la verifica prima del cambio.",
        tripadvisorChangePending: "Cambio richiesto a {name}. WhereToKnow lo verificherà prima del cambio; fino ad allora resta in uso la pagina sopra.",
        disconnectBodyTripadvisor: "Viene rimosso solo il collegamento: WhereToKnow continua a raccogliere le recensioni Tripadvisor di questa struttura. Puoi ricollegarti in qualsiasi momento.",
        tripadvisorPendingNote:'Inviato. WhereToKnow verificherà la scheda e la confermerà.',
        pendingStatus:'In attesa di conferma',
        noMatchingGoogleLocation:'Nessuna di queste sedi del Profilo dell\'attività è {name} su Google. Accedi con l\'account Google che gestisce {name} oppure contattaci se è in elenco.',
        useAnotherGoogleAccount:'Usa un altro account Google',
        thisProperty:'Questa struttura',
        promptTitle:'Collega il tuo Profilo dell\'attività su Google',
        promptBody:'Collega il Profilo dell\'attività di questa struttura così WhereToKnow può lavorare direttamente con le tue recensioni Google.',
        promptAction:'Collega',
        promptDismiss:'Chiudi',
        googleCancelled:'L\'accesso a Google è stato annullato.',
        googleFailed:'Impossibile collegare Google. Riprova.',
        startAgain:'Questo accesso a Google non corrisponde a nessuna struttura. Avvia di nuovo la connessione.',
    },
    // 读屏用的 aria-label
    A11y:{
        close:'Chiudi',
        openMenu:'Apri menu',
        scrollLeft:'Scorri a sinistra',
        scrollRight:'Scorri a destra',
        togglePanel:'Espandi/comprimi',
    },
    // 右下角帮助聊天气泡（components/common/SupportChatbot.vue）。msg 里的 \n 会被渲染成换行
    StaffTickets:{
        Kind_reviews:'Casi recensioni',
        Kind_staff:'Segnalazioni staff',
        Detail_title:'Segnalazione #{id}',
        Report:'Segnalazione',
        Status:'Stato',
        Priority:'Priorità',
        Category:'Categoria',
        Owner:'Responsabile',
        Reported_by:'Segnalato da',
        Reported_on:'Segnalato il',
        Days_open:'Giorni aperto',
        Date_from:'Da',
        Date_to:'A',
        Search:'Cerca segnalazioni',
        Reset:'Reimposta',
        Open:'Aperto',
        Under_Review:'In revisione',
        Actioned:'Gestito',
        Closed:'Chiuso',
        High:'Alta',
        Medium:'Media',
        Low:'Bassa',
        No_priority:'Nessuna priorità',
        Unassigned:'Non assegnato',
        Owners_failed:'Impossibile caricare i membri del team.',
        No_owners:'Nessun membro del team',
        Photo_report:'Segnalazione con foto',
        Photo_failed:'Impossibile caricare questa foto.',
        Handling:'Gestione',
        Note:'Nota',
        Note_cleared:'(cancellata)',
        Remark:'Commento',
        History:'Cronologia',
        History_created:'Segnalazione creata',
        Save:'Salva',
        Saved:'Salvato',
        Save_failed:'Salvataggio non riuscito. Riprova.',
        Close:'Chiudi',
        Retry:'Riprova',
        Load_failed:'Impossibile caricare le segnalazioni',
        Empty_title:'Nessuna segnalazione dello staff',
        Empty_body:'I problemi segnalati dal tuo team in hotel appariranno qui.',
        No_results:'Nessuna segnalazione per questi filtri',
    },
    SupportChatbot:{
        brandStatus:'Assistenza',
        title:'Come possiamo aiutarti?',
        subtitle:'Scegli un argomento o scrivi la tua domanda qui sotto.',
        placeholder:'Scrivi la tua domanda...',
        privacyPrefix:'Usando la chat accetti la nostra',
        privacyLink:'Informativa sulla privacy',
        privacySuffix:'',
        contactTitle:"Contatta l'assistenza",
        contactBody:'Inviaci un messaggio dettagliato e ti risponderemo entro 1 giorno lavorativo.',
        noMatch:'Non sono riuscito a capire la richiesta. Ecco le opzioni principali:',
        opt:{
            learnFeature:'Scopri una funzionalità',
            contactSupport:'Contatta il team di supporto',
            reportIssue:'Segnala un problema',
            wqi:'WQI',
            hotelOverview:'Panoramica hotel',
            hotelCompetitors:'Concorrenti hotel',
            restaurantOverview:'Panoramica ristorante',
            restaurantCompetitors:'Concorrenti ristorante',
            replySetting:'Impostazioni risposta',
            replyLibrary:'Libreria risposte',
            needsAttention:'Da gestire',
            reports:'Report',
            brandOverview:'Panoramica marchio',
            staffLeaderboard:'Classifica menzioni staff',
            settings:'Impostazioni, obiettivi e notifiche',
            backToMain:'Torna al menu principale',
            gotIt:'Ho capito',
            needMoreHelp:'Ho bisogno di altro aiuto',
            back:'Indietro',
            adjustCompSet:'Vorrei modificare il mio set competitivo',
            dataMissing:'Dati non caricati o mancanti',
            crashError:'Crash, errore o problema di visualizzazione',
            resolvedIt:'Problema risolto',
            stillMissing:"Mancano ancora — scrivi all'assistenza",
            emailSupport:'Scrivi al team di supporto',
            anotherQuestion:"Sì, un'altra domanda",
            thatsAll:'No, è tutto',
            helpful:'Sì, è stata utile',
            notReally:'Non molto',
        },
        msg:{
            start:'Come posso aiutarti oggi?',
            featureHelp:'Su quale area vorresti saperne di più?',
            reportBug:'Ci scusiamo per il disagio. Che tipo di problema stai riscontrando?',
            bugData:"Se i dati mancano o non sono aggiornati, prova a:\n\n1. Controllare l'orario di “Ultimo aggiornamento” — i dati si aggiornano ogni 2–4 ore\n2. Scegliere un intervallo di date diverso\n3. Ricaricare completamente la pagina (Ctrl+Maiusc+R / Cmd+Shift+R)\n\nSe dopo 4 ore i dati mancano ancora, il nostro team può verificare.",
            bugOther:"Per aiutarci a risolvere il problema, scrivici un'email indicando:\n\n• La pagina o la sezione\n• Cosa hai fatto subito prima del problema\n• Cosa ti aspettavi e cosa è successo\n• Uno screenshot, se possibile",
            connectHuman:'Il nostro team di supporto è felice di aiutarti. Di solito rispondiamo entro 1 giorno lavorativo.',
            resolved:'Felice di esserti stato utile. Posso aiutarti in altro?',
            feedback:'Prima di andare — questa conversazione ti è stata utile?',
            feedbackPositive:'Grazie per il feedback. Buona giornata.',
            feedbackNegative:'Grazie per la sincerità. Puoi contattare direttamente il nostro team di supporto, che sarà felice di aiutarti:',
            library:"La Libreria risposte è la tua raccolta personale di risposte alle recensioni salvate.\n\n• Clicca sull'icona a cuore di una risposta per salvarla\n• Ogni risposta salvata conserva la recensione originale, la tua risposta, la fonte OTA, i punteggi e le aree interessate\n• Aggiungi i tag “Motivo del salvataggio” e “Caso d'uso” per organizzare la raccolta\n• Puoi modificare in qualsiasi momento risposte, motivi e tag salvati\n• Filtra per data, fonte OTA, aree interessate o cerca per parola chiave",
            reports:"Report:\n\n• Periodi disponibili: settimanale, mensile, trimestrale, semestrale e annuale\n• Ogni report include punteggi per categoria, panoramica dei trend, priorità di gestione e piani d'azione pronti per i reparti\n• I report settimanali si aggiornano ogni lunedì, quelli mensili il 1° di ogni mese\n• Indicatore di affidabilità dei dati: Verde = oltre 50 recensioni (alta affidabilità), Giallo = 10–50, Rosso = meno di 10\n• Usa i pulsanti “Periodo precedente” / “Periodo successivo” per confrontare i periodi",
            hotel:{
                wqi:"Il WQI è una valutazione generata dall'AI (1–10) basata sul reale sentiment degli ospiti su tutte le tue piattaforme di recensioni.\n\nA differenza delle semplici medie, analizza il testo completo e l'intensità emotiva di ogni recensione in 7 categorie: Servizio, Pulizia, Camere, F&B, Servizi, Posizione e Rapporto qualità-prezzo.\n\nFasce di punteggio:\n• 9–10: Eccezionale\n• 8–9: Ottimo\n• 7–8: Buono\n• 6–7: Da migliorare\n• Sotto 6: Attenzione urgente",
                dashboard:'Panoramica hotel in breve:\n\n• I dati si aggiornano automaticamente ogni 2–4 ore\n• Usa le schede delle piattaforme (Booking.com, Google, Expedia…) per filtrare per fonte\n• Clicca su un cerchio KPI per vedere sottocategorie e singole recensioni\n• La classifica delle menzioni dello staff mostra quali membri del team vengono citati dagli ospiti e se in modo positivo o negativo\n• La classifica delle menzioni F&B raccoglie i punti salienti su cibo e bevande dalle recensioni',
                competitors:"Concorrenti hotel:\n\n• Il tuo set competitivo iniziale viene creato da WTK in base a posizione, categoria, fascia di prezzo e sovrapposizione degli ospiti\n• Puoi richiedere modifiche al set competitivo in qualsiasi momento — l'aggiornamento richiede 24–48 ore\n• Standard: 5 concorrenti · Professional: fino a 10 · Enterprise: personalizzato\n• Tutti i dati sui concorrenti provengono esclusivamente da OTA e piattaforme di recensioni pubbliche",
                reply:"Impostazioni risposta:\n\n• Scegli un preset di brand (Formale elegante, Premium caloroso, Informale giocoso, Minimal neutro) per definire il tuo tono\n• Regola formalità, contrazioni, emoji e umorismo in base al tuo brand\n• Imposta la lingua su Automatica (risposta nella lingua dell'ospite) o Fissa\n• Usa le Smart Replies per inserire automaticamente frasi personalizzate quando vengono citati argomenti specifici\n• Imposta la lunghezza: Breve (30–60 parole) per le OTA, Standard, Dettagliata o Dinamica",
                attention:'Da gestire usa i segnali di rischio AI per segnalare automaticamente le recensioni che richiedono un intervento immediato.\n\nOgni recensione segnalata mostra un tag “Avviso automatico” e fino a due tag di segnale di rischio:\n• Discrepanza valutazione–esperienza — divario tra punteggio OTA e analisi WTK\n• Estremamente negativa — sentiment fortemente negativo in più categorie\n• Solo negativa — nessun aspetto positivo\n\nPer ogni recensione puoi impostare la priorità (Alta / Media / Bassa), aggiornare lo stato (Aperta → Gestita → Chiusa) e aggiungere note di gestione. I giorni dalla pubblicazione sono indicati a colori: verde (≤3), arancione (3–5), rosso (>5).',
                brand:"La panoramica del marchio offre insight su più strutture del tuo gruppo alberghiero.\n\n• Classifiche globali e regionali — scopri come si posiziona ogni hotel all'interno del marchio\n• Performance per livello di membership — come i diversi livelli fedeltà valutano il soggiorno\n• Coerenza ed espressione del marchio — monitora allineamento, espressione culturale locale, innovazione e intenzione di raccomandare\n• Usa la vista mappa e il selettore di regione per esplorare le strutture",
                settings:"Impostazioni, obiettivi e notifiche:\n\n• Imposta punteggi obiettivo per ciascuna delle 7 categorie KPI — la dashboard mostra Differenza = Effettivo – Obiettivo in tempo reale\n• Gli obiettivi si possono modificare in qualsiasi momento e valgono per singola struttura\n• Notifiche: attiva gli avvisi email per gli avvisi sul punteggio OTA (soglie per piattaforma) e per i segnali di rischio AI (discrepanza valutazione–esperienza, recensione solo negativa)\n• Su Trip.com il punteggio massimo è 10 per impostazione predefinita, 5 con la lingua cinese\n• Aggiungi più destinatari email nella sezione Destinatari notifiche\n• L'email di accesso non può essere modificata dalle Impostazioni — contatta il tuo amministratore o il nostro team di supporto",
            },
            restaurant:{
                wqi:"Il WQI è una valutazione generata dall'AI (1–10) basata sul reale sentiment degli ospiti su tutte le tue piattaforme di recensioni.\n\nA differenza delle semplici medie, analizza il testo completo e l'intensità emotiva di ogni recensione in 7 categorie: Qualità del cibo, Servizio, Atmosfera, Pulizia, Rapporto qualità-prezzo, Gestione degli allergeni ed Esperienza complessiva.\n\nFasce di punteggio:\n• 9–10: Eccezionale\n• 8–9: Ottimo\n• 7–8: Buono\n• 6–7: Da migliorare\n• Sotto 6: Attenzione urgente",
                dashboard:'Panoramica ristorante in breve:\n\n• I dati si aggiornano automaticamente ogni 2–4 ore\n• Usa le schede delle piattaforme (Booking.com, Google, TripAdvisor…) per filtrare per fonte\n• Clicca su un cerchio KPI per vedere sottocategorie e singole recensioni\n• La classifica delle menzioni dello staff mostra quali membri del team vengono citati dagli ospiti e se in modo positivo o negativo\n• Monitora i piatti più apprezzati, le richieste speciali e le preferenze alimentari dal feedback degli ospiti',
                competitors:"Concorrenti ristorante:\n\n• Il tuo set competitivo iniziale viene creato da WTK in base a tipo di cucina, posizione, fascia di prezzo e sovrapposizione degli ospiti\n• Puoi richiedere modifiche al set competitivo in qualsiasi momento — l'aggiornamento richiede 24–48 ore\n• Tutti i dati sui concorrenti provengono esclusivamente da OTA e piattaforme di recensioni pubbliche",
                reply:"Impostazioni risposta:\n\n• Scegli un preset di brand per definire il tuo tono (Professionale, Caloroso, Informale, Minimal)\n• Regola formalità, contrazioni, emoji e umorismo in base al tuo brand\n• Imposta la lingua su Automatica (risposta nella lingua dell'ospite) o Fissa\n• Usa le Smart Replies per inserire automaticamente risposte personalizzate quando vengono citati cucina, allergeni o servizio\n• Imposta la lunghezza: Breve (30–60 parole), Standard, Dettagliata o Dinamica",
                attention:'Da gestire usa i segnali di rischio AI per segnalare automaticamente le recensioni che richiedono un intervento immediato.\n\nOgni recensione segnalata mostra un tag “Avviso automatico” e fino a due tag di segnale di rischio:\n• Discrepanza di punteggio — divario tra punteggio OTA e analisi WTK\n• Estremamente negativa — sentiment fortemente negativo in più categorie\n• Solo negativa — nessun aspetto positivo\n\nPer ogni recensione puoi impostare la priorità (Alta / Media / Bassa), aggiornare lo stato e aggiungere note di gestione.',
                staff:'Classifica delle menzioni dello staff:\n\n• Rileva automaticamente i membri del team citati nelle recensioni degli ospiti\n• Mostra numero di menzioni, sentiment (positivo / negativo) e feedback principali\n• Aiuta a individuare i migliori e a riconoscere un servizio eccellente\n• Usa la classifica per capire quali membri dello staff incidono di più sulla soddisfazione degli ospiti\n• Filtra per intervallo di date e fonte OTA',
                settings:"Impostazioni, obiettivi e notifiche:\n\n• Imposta punteggi obiettivo per ciascuna delle 7 categorie KPI — la dashboard mostra Differenza = Effettivo – Obiettivo in tempo reale\n• Gli obiettivi si possono modificare in qualsiasi momento e valgono per singolo ristorante\n• Notifiche: attiva gli avvisi email per gli avvisi sul punteggio OTA e per i segnali di rischio AI\n• Aggiungi più destinatari email nella sezione Destinatari notifiche\n• L'email di accesso non può essere modificata dalle Impostazioni — contatta il tuo amministratore o il nostro team di supporto",
            },
        },
    },
    // WTK-913 专属关注卡片
    CustomCategories:{
        retired:'Ritirato',
        footerLabel:'Menzioni',
        footerValue:'{count} su {analysed} recensioni',
        general:'Generale',
    },
    // WTK-913 报告里的专属关注
    ReportFocusTopics:{
        reviews:'{n} recensione | {n} recensioni',
        noMentions:'Nessuna menzione in questo periodo',
        noIssues:'Nessun problema segnalato',
        trend:'Andamento',
        tips:'Suggerimenti per {name}',
        quotes:'Cosa hanno scritto gli ospiti',
    },
}
